import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { companyTypesService } from "../services/companyType.service";

export const fetchCompanyTypes = createAsyncThunk("companyType/fetchAll", async (_, thunkAPI) => {
  try {
    return await companyTypesService.getCompanyTypes();
  } catch (err) {
    return thunkAPI.rejectWithValue("Failed to fetch company types.");
  }
});

export const fetchCompanyTypeById = createAsyncThunk("companyType/fetchById", async (id, thunkAPI) => {
  try {
    return await companyTypesService.getCompanyTypeById(id);
  } catch (err) {
    return thunkAPI.rejectWithValue("Failed to fetch company type");
  }
});

export const addCompanyType = createAsyncThunk("companyType/add", async (companyType, thunkAPI) => {
  try {
    return await companyTypesService.createCompanyType(companyType);
  } catch (err) {
    return thunkAPI.rejectWithValue("Failed to create company type");
  }
});

export const editCompanyType = createAsyncThunk("companyType/edit", async ({ id, companyType }, thunkAPI) => {
  try {
    return await companyTypesService.updateCompanyType(id, companyType);
  } catch (err) {
    return thunkAPI.rejectWithValue("Failed to update company type");
  }
});

export const removeCompanyType = createAsyncThunk("companyType/remove", async (id, thunkAPI) => {
  try {
    await companyTypesService.deleteCompanyType(id);
    return id;
  } catch (err) {
    return thunkAPI.rejectWithValue("Failed to delete company type");
  }
});

const companyTypeSlice = createSlice({
  name: "companyType",
  initialState: { companyTypes: [], totalCount: 0, companyType: null, loading: false, error: null, showModal: false, showDeleteModal: false },
  reducers: {
    openModal: (state) => { state.showModal = true },
    closeModal: (state) => { state.showModal = false },
    openDeleteModal: (state) => { state.showDeleteModal = true },
    closeDeleteModal: (state) => { state.showDeleteModal = false }
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchCompanyTypes.pending, (state) => { state.loading = true; state.error = null })
      .addCase(fetchCompanyTypes.fulfilled, (state, action) => { state.loading = false; state.companyTypes = action.payload })
      .addCase(fetchCompanyTypes.rejected, (state, action) => { state.loading = false; state.error = action.payload })
      .addCase(fetchCompanyTypeById.fulfilled, (state, action) => { state.companyType = action.payload })
      .addCase(addCompanyType.pending, (state) => { state.loading = true })
      .addCase(addCompanyType.fulfilled, (state, action) => {
        state.companyTypes = [action.payload, ...state.companyTypes]
        state.loading = false
        state.showModal = false
      })
      .addCase(editCompanyType.pending, (state) => { state.loading = true })
      .addCase(editCompanyType.fulfilled, (state, action) => {
        const edited = action.meta.arg;
        state.companyTypes = state.companyTypes.map((c) =>
          c.companyTypeId === edited.id ? { ...edited.companyType, companyTypeId: edited.id } : c
        );
        state.loading = false
        state.showModal = false
      })
      .addCase(removeCompanyType.pending, (state) => { state.loading = true })
      .addCase(removeCompanyType.fulfilled, (state, action) => {
        state.companyTypes = state.companyTypes.filter((s) => s.companyTypeId !== action.payload);
        state.loading = false
        state.showDeleteModal = false
      })
      .addCase(removeCompanyType.rejected, (state) => { state.loading = false });
  },
});

export const { openModal, closeModal, openDeleteModal, closeDeleteModal } = companyTypeSlice.actions;
export default companyTypeSlice.reducer;